import { ROUTES } from '@/constants/routes';
import { SVLink } from './core';
import { Typography } from '@mui/material';
import { useGetUser } from '@/hooks/requests/useUser';

type TeammateLinkProps = {
  uuid: string;
  name: string;
};

export default function TeammateLink({ uuid, name }: TeammateLinkProps) {
  const { canSeeTeammates } = useGetUser();
  if (canSeeTeammates) {
    return <SVLink to={`${ROUTES.TEAMMATES}/${uuid}`}>{name}</SVLink>;
  }

  return <Typography>{name}</Typography>;
}
